import React from "react";

const smartHomeSolutions = [
  {
    title: "Modern Living",
    description:
      "We believe that home should be a space where meaningful touchpoints trigger emotion. Natural light, prevailing winds, letting nature indoors. Design should connect you to a space.",
  },
  {
    title: "Smart Home Architecture",
    description:
      "We bring decades of experience in architecture, interior design and construction. Together, we are a practice that is committed to this idea of smart living, by design.",
  },
  {
    title: "Smart Home Management",
    description:
      "In a Modern Smart Home, you feel aware. You feel connected. You feel both at peace and empowered. That’s what happens when Smart Design, Smart Nature, Smart Construction and Smart Systems are at work.",
  },
  {
    title: "Exploring Features",
    description:
      "We pursue the most cost-effective and reliable technology for each property—that’s working smart.​",
  },
];

const SmartHomeSolution = () => {
  return (
    <section className="" id="smart-home-solution">
      <div className="container-fluid smart-home-solution">
        <div className="ms-13 me-13 pt-13 pb-7">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-6 order-1 order-lg-0 mb-5 mb-lg-0">
              <div className="me-lg-5 pe-lg-5">
                <h1 className="plex-sans fs-56 lh-64 mb-5">
                  Smart Home <br />{" "}
                  <span className="text-orange-ryb">Solution</span>
                </h1>
                <p className="fs-20 lh-30 text-align-justify">
                  Imagine every one of the gadgets in your day to day existence
                  could come alive… everything: clocks, speakers, lights,
                  doorbells, cameras, windows, window blinds, boiling water
                  radiators, apparatuses, cooking tools, beds and more..
                </p>
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-6 my-auto order-0 order-lg-1">
              {smartHomeSolutions.map((solution, index) => (
                <div className="row" key={solution.title}>
                  <h2
                    className="col-2 text-24 gilroy-bold bg-american-yellow text-center me-4"
                    style={{
                      height: "40px",
                      width: "40px",
                      borderRadius: "50%",
                      lineHeight: "40px",
                    }}
                  >
                    {index + 1}
                  </h2>
                  <div className="col-10 mb-lg-4">
                    <h3 className="fs-18 gilroy-bold">{solution.title}</h3>
                    <p className="fs-16 lh-30">{solution.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SmartHomeSolution;
